var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04688 0.434687V2.17388C9.04688 2.41394 9.24973 2.60872 9.49974 2.60872C9.74975 2.60872 9.95261 2.41394 9.95261 2.17388V0.434687C9.95261 0.194778 9.74975 0 9.49974 0C9.24973 0 9.04688 0.194782 9.04688 0.434687Z",
    fill: "#BCBCBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58018 1.81627L5.48592 3.32239C5.61085 3.53027 5.88798 3.60161 6.10436 3.4815C6.32086 3.36155 6.39515 3.09545 6.27022 2.88754L5.36449 1.38141C5.23956 1.17368 4.96243 1.10234 4.74589 1.2223C4.52954 1.34225 4.45525 1.60835 4.58018 1.81627Z",
    fill: "#BCBCBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43056 5.15897L2.99914 6.0285C3.21564 6.1486 3.49265 6.07726 3.61774 5.86938C3.74267 5.66165 3.66838 5.39553 3.45203 5.27541L1.88329 4.40589C1.66694 4.28594 1.38979 4.35727 1.26485 4.565C1.13977 4.77289 1.21406 5.03901 1.43056 5.15897Z",
    fill: "#BCBCBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.444078 9.56484H2.25524C2.50524 9.56484 2.7081 9.37005 2.7081 9.13015C2.7081 8.89009 2.50524 8.69531 2.25524 8.69531H0.444078C0.19407 8.69531 -0.00878906 8.89009 -0.00878906 9.13015C-0.00878906 9.37006 0.19407 9.56484 0.444078 9.56484Z",
    fill: "#BCBCBC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88329 13.8547L3.45203 12.9851C3.66838 12.8652 3.74267 12.5991 3.61774 12.3912C3.49266 12.1834 3.21568 12.1121 2.99914 12.2321L1.43056 13.1016C1.21406 13.2217 1.13977 13.4878 1.26485 13.6956C1.38978 13.9034 1.66691 13.9748 1.88329 13.8547Z",
    fill: "#BCBCBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5478 12.9851L17.1163 13.8547C17.3328 13.9748 17.6098 13.9034 17.7349 13.6956C17.8599 13.4878 17.7856 13.2217 17.5692 13.1016L16.0005 12.2321C15.7841 12.1121 15.507 12.1834 15.382 12.3912C15.257 12.5991 15.3312 12.8652 15.5478 12.9851Z",
    fill: "#BCBCBC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7458 9.56484H18.557C18.807 9.56484 19.0099 9.37005 19.0099 9.13015C19.0099 8.89009 18.807 8.69531 18.557 8.69531H16.7458C16.4958 8.69531 16.293 8.89009 16.293 9.13015C16.293 9.37006 16.4958 9.56484 16.7458 9.56484Z",
    fill: "#BCBCBC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0005 6.0285L17.5692 5.15897C17.7856 5.03902 17.8599 4.77292 17.7349 4.565C17.6098 4.35727 17.3329 4.28594 17.1163 4.40589L15.5478 5.27541C15.3312 5.39552 15.257 5.66162 15.382 5.86938C15.507 6.07726 15.7841 6.1486 16.0005 6.0285Z",
    fill: "#BCBCBC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5149 3.32438L14.4205 1.81825C14.5456 1.61037 14.4713 1.34425 14.2548 1.22429C14.0383 1.10432 13.7613 1.17552 13.6362 1.3834L12.7306 2.88952C12.6057 3.09741 12.6798 3.36353 12.8963 3.48349C13.1128 3.60346 13.39 3.53226 13.5149 3.32438Z",
    fill: "#BCBCBC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33031 14.5467V15.2179C6.33031 15.9384 6.93843 16.5223 7.68875 16.5223H11.3114C12.0617 16.5223 12.6698 15.9384 12.6698 15.2179C12.6698 15.007 12.6698 14.78 12.6806 14.5679C12.681 14.5609 12.681 14.5535 12.681 14.5462C12.681 14.1536 12.8668 13.7823 13.1859 13.5371C13.1864 13.5367 13.1864 13.5367 13.1868 13.5362C14.5282 12.5 15.3867 10.9109 15.3867 9.13086C15.3867 6.01117 12.749 3.47852 9.50001 3.47852C6.25103 3.47852 3.61328 6.0111 3.61328 9.13086C3.61328 10.9112 4.47232 12.5008 5.82122 13.5288C6.14279 13.7761 6.33017 14.1506 6.33017 14.5466L6.33031 14.5467ZM7.23604 15.2179V14.5462C7.23604 13.8867 6.92357 13.2623 6.38701 12.8501C6.38656 12.8497 6.3861 12.8493 6.38565 12.8488C5.2449 11.98 4.51915 10.6362 4.51915 9.13095C4.51915 6.49137 6.75103 4.34805 9.49998 4.34805C12.2489 4.34805 14.4808 6.49122 14.4808 9.13095C14.4808 10.6374 13.7537 11.9818 12.6189 12.8588C12.0877 13.2676 11.7771 13.8863 11.7753 14.5407C11.7639 14.7549 11.7639 14.995 11.7639 15.218C11.7639 15.4581 11.5611 15.6529 11.3112 15.6529H7.68859C7.43874 15.6529 7.23588 15.4581 7.23588 15.218L7.23604 15.2179Z",
    fill: "#BCBCBC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78295 18.2603H12.2167C12.4667 18.2603 12.6696 18.0655 12.6696 17.8255C12.6696 17.5854 12.4667 17.3906 12.2167 17.3906H6.78295C6.53294 17.3906 6.33008 17.5854 6.33008 17.8255C6.33008 18.0655 6.53294 18.2603 6.78295 18.2603Z",
    fill: "#BCBCBC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68904 20.0004H11.3117C11.5615 20.0004 11.7644 19.8056 11.7644 19.5657C11.7644 19.3256 11.5615 19.1309 11.3117 19.1309H7.68904C7.43918 19.1309 7.23633 19.3256 7.23633 19.5657C7.23633 19.8056 7.43919 20.0004 7.68904 20.0004Z",
    fill: "#BCBCBC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50072 6.52202C11 6.52202 12.2176 7.69113 12.2176 9.13074C12.2176 9.37064 12.4205 9.56542 12.6705 9.56542C12.9203 9.56542 13.1232 9.37064 13.1232 9.13074C13.1232 7.21117 11.4999 5.65234 9.50072 5.65234C9.25071 5.65234 9.04785 5.84713 9.04785 6.08718C9.04785 6.32723 9.25071 6.52202 9.50072 6.52202Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbIcon);
export default __webpack_public_path__ + "static/media/bulbIcon.0fe07cd3b5c4f12327d1cca568b2a9da.svg";
export { ForwardRef as ReactComponent };